import useApi from './request';

export interface DramaDetail {
  id?: number;
  userId?: string;
  dramaName?: string;
  dramaIntro?: string;
  dramaCover?: string;
  dramaStatus?: number;
  totalEpisodes?: number;
  currentEpisodes?: number;
}

export async function getDramaDetail(dramaId: string | number) {
  const { response, request } = useApi<{
    message?: string;
    result?: DramaDetail;
  }>(`/drama/official/detail/${dramaId}`, {
    method: 'post',
  });
  await request();
  return response;
}
